import AdminActionType from "../Actions/AdminAction/AdminActionType";

export default function AdminReducer(state = {
    DashBoardData: "",
    gameSurveyList: [],
    paginationData: {}
}, action) {
    switch (action.type) {
        case AdminActionType.AdminDash:
            return {
                ...state,
                DashBoardData: action.res
            };
        case 'FETCH_USER_GAMES_SURVEY_SUCCESS':
            return {
                ...state,
                gameSurveyList: formatUserData(action.payload?.usr_data),
                paginationData: { totalCount: action.payload?.total_count, currentPage: action.payload?.current_page }
            }
        default: return state
    }

}

const formatDate = (date) => {
    const parsedDate = new Date(date);
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(parsedDate);
    const [month, day, year] = formattedDate.split(' ');
    return `${month} ${day}/${year}`;
}

const formatUserData = (data) => {
    return data?.map((item) => ({
        "id": item?.id,
        "email": item?.email,
        "uuid": item?.uuid,
        "status": item?.status,
        'survey_name': item?.survey_name?.length ? item?.survey_name.join(", ") : 'N/A',
        'game_name': item?.game_name?.length ? item?.game_name?.map(value => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()).join(", ") : 'N/A',
        "attempt_start_date": (item?.attempt_start_date && formatDate(item?.attempt_start_date)) || "N/A",
        "attempt_completion_date": (item?.attempt_completion_date && formatDate(item?.attempt_completion_date)) || "N/A",
        "first_name": item?.first_name,
    }))
}